$(document).ready(function() {
  if ($(".sezam_welcome").css("display") == 'block')  {
    $("body").css("overflow", "hidden");
  }
});
